import { CreditsTransactionTypes } from 'swag-common/interfaces';
export let InventoryManagementSorting = /*#__PURE__*/function (InventoryManagementSorting) {
  InventoryManagementSorting["StorageFeeASC"] = "storage-fee-ASC";
  InventoryManagementSorting["StorageFeeDESC"] = "storage-fee-DESC";
  InventoryManagementSorting["CreditsASC"] = "credits-ASC";
  InventoryManagementSorting["CreditsDESC"] = "credits-DESC";
  InventoryManagementSorting["CreatedAtDESC"] = "createdAt-DESC";
  return InventoryManagementSorting;
}({});
export const ADMIN_CREDITS_TYPES_TITLES = {
  [CreditsTransactionTypes.BUY]: 'Buy',
  [CreditsTransactionTypes.WITHDRAW]: 'Withdraw',
  [CreditsTransactionTypes.ADJUSTMENT]: 'Adjustment'
};
export const ADMIN_CREDITS_TYPES_SEQUENCE = [CreditsTransactionTypes.BUY, CreditsTransactionTypes.WITHDRAW, CreditsTransactionTypes.ADJUSTMENT];
export const MIN_WITHDRAW_CREDITS_AMOUNT = 100;
export const MIN_TO_BUY_CREDITS_AMOUNT = 100;
export const MIN_TO_BUY_CREDITS_AMOUNT_WITH_DECIMALS = 10000;
export const MIN_WITHDRAW_CREDITS_AMOUNT_WITH_DECIMALS = 10000;
export const MAX_TO_BUY_CREDITS_AMOUNT = 999999;
export const MAX_TO_BUY_CREDITS_AMOUNT_WITH_DECIMALS = 99999999;
export const CREDITS_PREFIX = 'cre-';